import React from 'react';
import { getCostForAddon } from '../utils';

export const DURATIONS = {
  STANDARD: 'STANDARD',
  LONGFORM_SHORT: 'LONGFORM_SHORT',
  LONGFORM_MEDIUM: 'LONGFORM_MEDIUM',
  LONGFORM_LONG: 'LONGFORM_LONG'
};

const ICON = 'longform2';

export default function () {
  return ({
    billingEntityCode,
    addonsCosts,
    includedAddons




  }) => {
    const zeroCost = getCostForAddon({ billingEntityCode, costs: null });
    const shortCost = includedAddons.includes('LONGFORM_SHORT') ? zeroCost : getCostForAddon({ costs: addonsCosts.LONGFORM_SHORT.costs, billingEntityCode });
    const mediumCost = includedAddons.includes('LONGFORM_MEDIUM') ? zeroCost : getCostForAddon({ costs: addonsCosts.LONGFORM_MEDIUM.costs, billingEntityCode });
    const longCost = includedAddons.includes('LONGFORM_LONG') ? zeroCost : getCostForAddon({ costs: addonsCosts.LONGFORM_LONG.costs, billingEntityCode });

    return [
    { label: 'Longform 5-10 min', value: DURATIONS.LONGFORM_SHORT, suffix: <span>{shortCost}</span>, icon: ICON, cost: shortCost },
    { label: 'Longform 10-20 min', value: DURATIONS.LONGFORM_MEDIUM, suffix: <span>{mediumCost}</span>, icon: ICON, cost: mediumCost },
    { label: 'Longform 20+ min', value: DURATIONS.LONGFORM_LONG, suffix: <span>{longCost}</span>, icon: ICON, cost: longCost }];

  };
}